import type { CSSProperties, FC } from 'react';
import { Flex, Typography } from '@ui';
import { motion } from 'framer-motion';
import { getJustifyStyle } from '@/ui/utils/getJustifyStyle';
import styles from './Progress.module.css';

type Props = {
    width?: CSSProperties['width'];
    value?: number;
    max?: number;
    title?: string;
    showPercentageSign?: boolean;
};

export const Progress: FC<Props> = ({ value, max = 100, width, title, showPercentageSign = true }) => {
    const justify = getJustifyStyle(title, true);
    const percentage = value ? Math.round((value / max) * 100) : 0;
    return (
        <Flex vertical gap={8} style={{ width }}>
            <Flex justify={justify} className={styles.title}>
                {title && <Typography.Action>{title}</Typography.Action>}
                <Typography.Action>
                    {percentage}
                    {showPercentageSign ? '%' : ''}
                </Typography.Action>
            </Flex>
            <div aria-hidden className={styles.progress}>
                <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${percentage}%` }}
                    transition={{
                        type: 'spring',
                        stiffness: 600,
                        damping: 30,
                        ease: [0.78, 0.14, 0.15, 0.86]
                    }}
                    className={styles.progressBar}
                />
            </div>
        </Flex>
    );
};
